module.exports = __webpack_public_path__ + "ota-facility-icon.9115b50ff74c4712a421.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ota-facility-icon/fonts/ota-facility-icon.svg?bot94j
// module id = 967
// module chunks = 24